export enum ClockingInScope {
  workingSite, user
}
